import type { Action } from 'svelte/action';
import { SECTION_CONFIG } from '../../constants/section-config';
import { trackOnwardClicks as trackOnwardClicksWithConfig } from '$global/utils/onwardClick/trackOnwardClicks/trackOnwardClicks';
import type { TrackOnwardClicksParams } from '$global/utils/onwardClick/trackOnwardClicks/trackOnwardClicks';

export type TrackHeniOnwardClicksParams = Omit<
	TrackOnwardClicksParams,
	'config'
>;

/**
 * The delegated `onward_click` action bound to the heni.com route map (HB-967).
 *
 * Wraps the global-v5 action so `use:` sites pass only what varies per surface
 * and never name the section config themselves.
 */
export const trackOnwardClicks: Action<
	HTMLElement,
	TrackHeniOnwardClicksParams
> = (node, params: TrackHeniOnwardClicksParams) => {
	const withConfig = (
		next: TrackHeniOnwardClicksParams
	): TrackOnwardClicksParams => ({
		...next,
		config: SECTION_CONFIG,
	});

	const action = trackOnwardClicksWithConfig(node, withConfig(params));

	return {
		update: (next: TrackHeniOnwardClicksParams) =>
			action?.update?.(withConfig(next)),
		destroy: () => action?.destroy?.(),
	};
};
